import React from 'react';
import Observable from '@/utils/observers/ObserverPattern';
import TreeCourses, { CoursesNode } from '@/utils/trees/TreeCourses';
import {
  createContext,
  MutableRefObject,
  PropsWithChildren,
  useContext,
  useEffect,
  useRef,
} from 'react';
import { useCourseSegments } from '@/data/hook/course-line/useCoursesSegments';

type TreeCoursesContextProps = {
  tree?: MutableRefObject<TreeCourses>;
  pathObserver?: Observable<string, CoursesNode[]>;
};

const TreeCoursesContext = createContext<TreeCoursesContextProps>({
  tree: undefined,
});

const root: CoursesNode = {
  id: 'root',
  name: 'Root',
  type: 'root',
  realId: 0,
};

export const TreeCoursesProvider: React.FC<PropsWithChildren> = ({
  children,
}) => {
  const { segments } = useCourseSegments();

  const tree = useRef(new TreeCourses({ root, segments }));

  useEffect(() => {
    tree.current.setSegments(segments);
  }, [segments]);

  return (
    <TreeCoursesContext.Provider
      value={{
        tree,
        pathObserver: tree.current.observer,
      }}
    >
      {children}
    </TreeCoursesContext.Provider>
  );
};

export const useTreeCourses = () => {
  return useContext(TreeCoursesContext);
};
